import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { projects, site } from "../data/site";

export default function PortfolioPage() {
  return (
    <>
      <SEO
        title="Project Photos | Polishing Singapore"
        description="Project image groups for stone restoration, commercial floor polishing, concrete floor work, hotel stone flooring and tile cleaning."
        canonical={`${site.domain}/portfolio`}
      />
      <PageHero title="Project Visuals and Surface Examples" description="Surface examples for stone restoration, restaurant flooring, concrete work, hotel flooring and tile cleaning." image="/assets/polishing/project_restaurant.webp" />
      <section className="section-pad bg-background-50">
        <div className="section-shell grid gap-8">
          {projects.map((project) => (
            <article key={project.title} className="surface-card overflow-hidden">
              <div className={`grid ${project.images.length > 1 ? "md:grid-cols-2" : ""}`}>
                {project.images.map((image) => (
                  <img key={image} src={image} alt={project.title} className="h-72 w-full object-cover md:h-96" />
                ))}
              </div>
              <div className="p-6 md:p-8">
                <p className="eyebrow">{project.tag}</p>
                <h2 className="mt-3 font-heading text-3xl font-bold">{project.title}</h2>
                <p className="mt-4 max-w-3xl text-base leading-8 text-foreground-700">{project.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
